<div class="document-div">
    <div class="document-type-div">
        <select (change)="onImageChange($event)">
            <option value="">Please select document</option>
            <option *ngFor="let document of uploadedDocuments; let i = index" value="{{i}}">{{uploadedDocumentsHeading[i]}}</option>
        </select>
    </div>
    <div class="document-container">
        <embed *ngIf="selectedIndex !== -1 && !uploadedDocuments[selectedIndex].contentType.startsWith('image')" [src]="uploadedDocuments[selectedIndex].url" [type]="uploadedDocuments[selectedIndex].contentType"/>        
        <img *ngIf="selectedIndex !== -1 && uploadedDocuments[selectedIndex].contentType.startsWith('image')" [src]="uploadedDocuments[selectedIndex].url" />        
    </div>
</div>
